// service.js
import axios from 'axios';
import { useApiHelper } from '../../utils/helper/apiHelper';

export const useCommonService = () => {
    const { get, post, loading } = useApiHelper();

    const ApiCalling = async (payload: any) => {
        try {
            return await post(`${import.meta.env.VITE_APP_API_URL}/ExecuteProcedure`, payload);
        } catch (error) {
            console.error('Error fetching dashboard data:', error);
            throw error;
        }
    };
    const ExecuteProcedure = async (payload: any) => {
        try {
            return await post(`${import.meta.env.VITE_APP_API_URL}/ExecuteProcedure`, payload);
        } catch (error) {
            console.error('Error fetching dashboard data:', error);
            throw error;
        }
    };
    const ProductJsontable = async (payload: any) => {
        try {
            
            return await post(`${import.meta.env.VITE_APP_API_URL}/ExecuteProcedureWithJsonString`, payload);
        } catch (error) {
            console.error('Error fetching dashboard data:', error);
            throw error;
        }
        // try {
        //         const response = await fetch(`${import.meta.env.VITE_APP_API_URL}/ExecuteProcedureWithJsonString`, {
        //         method: "POST",
        //         headers: {
        //             "Content-Type": "application/json"
        //         },
        //         body: JSON.stringify(payload)
        //         });

        //         const data = await response.json();
        //         console.log("✅ Success:", data);
        //     } catch (error) {
        //         console.error("❌ Error:", error);
        //     }
    };
   

    return {
        ApiCalling,
        loading,
        ExecuteProcedure,
        ProductJsontable
    };
};
